import React from "react";
import Container from "react-bootstrap/Container";
import Accordion from "react-bootstrap/Accordion";
import Badge from "react-bootstrap/Badge";
import Alert from "react-bootstrap/Alert";

import "bootstrap/dist/css/bootstrap.min.css";

const InvoicesVatUpdate1206 = () => {
  return (
    <Container className="mt-4 mb-5">
      <div className="d-flex align-items-center flex-wrap gap-2 mb-2">
        <h2 className="m-0">Оновлення фактур 12.06</h2>
        <Badge bg="success">Реалізовано</Badge>
      </div>
      <p className="text-muted">
        Новий механізм завантаження, перевірки та обробки фактур водіїв (ПДВ), а також автоматичного
        нарахування додаткових коштів на основі підтверджених фактур.
      </p>

      <Alert variant="info">
        <b>Коротко:</b> водій завантажує фото фактури і вказує лише суму ПДВ. Адміністратор перевіряє і
        підтверджує фактуру. Після масового створення додаткових коштів за тиждень усі підтверджені й ще не
        оброблені фактури автоматично додаються до поля «Повернення ПДВ» кожного водія, а самі фактури
        отримують статус «Оплачено».
      </Alert>

      <Accordion defaultActiveKey="0" alwaysOpen className="mb-4">
        {/* 1. Що змінилось */}
        <Accordion.Item eventKey="0">
          <Accordion.Header>1. Що змінилось</Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>
                Водій у своєму кабінеті може завантажити фактуру: вказати <b>суму ПДВ</b> і додати{" "}
                <b>фото/скан фактури</b> (jpg/png, до 5 МБ). Сума брутто більше не вводиться водієм.
              </li>
              <li>
                Кожна завантажена фактура одразу з'являється в адмін-панелі зі статусом{" "}
                <Badge bg="secondary">Завантажено</Badge> і чекає на перевірку.
              </li>
              <li>
                Адміністратор переглядає фактуру, за потреби коригує суму ПДВ (сума ПДВ від водія — головне
                значення, автоматичний розрахунок 23% від брутто залишився лише як допоміжна підказка) і
                підтверджує її — фактура отримує статус <Badge bg="primary">Підтверджено</Badge>.
              </li>
              <li>
                Сума повернення для водія розраховується автоматично від суми ПДВ за формулою:{" "}
                <b>ПДВ × % повернення − комісія за фактуру</b>.
              </li>
              <li>
                Під час масового створення додаткових коштів за обраний тиждень («Створити для всіх з
                дефолтними значеннями») система автоматично знаходить усі підтверджені й ще не оброблені
                фактури, підсумовує їх суму повернення для кожного водія і додає її в поле{" "}
                <b>«Повернення ПДВ»</b> додаткових коштів за цей тиждень.
              </li>
              <li>
                Фактури, які увійшли в такий розрахунок, автоматично переводяться у статус{" "}
                <Badge bg="success">Оплачено</Badge>, щоби не потрапити в підрахунок повторно наступного разу.
              </li>
              <li>
                Фото фактур захищені — доглянути їх може тільки сам водій (свої фактури) або адміністратор
                (усі фактури), сторонні за посиланням їх не побачать.
              </li>
              <li>Водій не може редагувати або видаляти вже завантажену фактуру.</li>
              <li>Обмежень на кількість фактур, які водій може завантажити, немає.</li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>

        {/* 2. Як було раніше */}
        <Accordion.Item eventKey="1">
          <Accordion.Header>2. Як було раніше</Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>Фактури водіїв міг створювати лише адміністратор вручну, водій не мав доступу до цього функціоналу.</li>
              <li>Не було зв'язку між фактурами та додатковими коштами — суми потрібно було переносити вручну.</li>
              <li>Поле «Повернення ПДВ» при масовому створенні додаткових коштів заповнювалось лише зі стандартних (дефолтних) значень, без урахування реальних фактур.</li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>

        {/* 3. Інструкція для водія */}
        <Accordion.Item eventKey="2">
          <Accordion.Header>3. Інструкція для водія — як завантажити фактуру</Accordion.Header>
          <Accordion.Body>
            <ol>
              <li>Відкрити кабінет водія, натиснути кнопку <b>«Додати фактуру»</b> у верхньому меню.</li>
              <li>Вказати суму ПДВ з фактури (поле обов'язкове, число ≥ 0).</li>
              <li>Додати фото або скан фактури (jpg/png, до 5 МБ) — поле обов'язкове.</li>
              <li>Натиснути «Завантажити». Фактура з'явиться у списку «Мої фактури» зі статусом «Завантажено».</li>
              <li>
                Після перевірки адміністратором статус фактури зміниться на «Підтверджено» (або «Відхилено», якщо
                є проблема — наприклад, нечітке фото чи невірна сума).
              </li>
              <li>
                Після того, як адміністратор сформує додаткові кошти за тиждень, підтверджена фактура отримає
                статус «Оплачено» — це означає, що сума повернення вже врахована в додаткових коштах водія.
              </li>
              <li>Редагувати чи видаляти завантажену фактуру водій не може — у разі помилки потрібно звернутись до адміністратора.</li>
            </ol>
          </Accordion.Body>
        </Accordion.Item>

        {/* 4. Інструкція для адміністратора — перевірка фактур */}
        <Accordion.Item eventKey="3">
          <Accordion.Header>4. Інструкція для адміністратора — перевірка фактур</Accordion.Header>
          <Accordion.Body>
            <ol>
              <li>Перейти в розділ <b>«Рахунки» → «Фактури водіїв»</b>.</li>
              <li>У списку знайти фактури зі статусом «Завантажено» — це нові, ще не перевірені фактури.</li>
              <li>Відкрити фактуру, переглянути фото/скан.</li>
              <li>
                Перевірити суму ПДВ, яку вказав водій (за потреби — скоригувати). Сума брутто — необов'язкове
                довідкове поле, розрахунок ПДВ 23% від брутто показується лише як підказка.
              </li>
              <li>Сума повернення розрахується автоматично на основі суми ПДВ.</li>
              <li>Натиснути «Затвердити» — фактура отримає статус «Підтверджено» і буде готова до нарахування, або «Відхилити», якщо фактура не підходить.</li>
            </ol>
          </Accordion.Body>
        </Accordion.Item>

        {/* 5. Інструкція для адміністратора — нарахування */}
        <Accordion.Item eventKey="4">
          <Accordion.Header>5. Інструкція для адміністратора — нарахування у додаткові кошти</Accordion.Header>
          <Accordion.Body>
            <ol>
              <li>Перейти в розділ <b>«Фінанси» → «Додаткові кошти»</b>.</li>
              <li>Обрати потрібний тиждень.</li>
              <li>Натиснути <b>«Створити для всіх з дефолтними значеннями»</b>.</li>
              <li>
                У вікні з опціями обов'язково залишити позначку <b>«Повернення ПДВ»</b> — саме ця опція запускає
                автоматичний підрахунок фактур.
              </li>
              <li>
                Підтвердити дію. Система знайде всі підтверджені й ще не оброблені фактури за всіх водіїв,
                підсумує суму повернення для кожного водія і додасть її в поле «Повернення ПДВ» додаткових
                коштів обраного тижня (з урахуванням уже існуючих значень — сума додається, а не перезаписується).
              </li>
              <li>
                Після завершення з'явиться підсумок: скільки фактур і скільки водіїв було оброблено, на яку
                загальну суму.
              </li>
              <li>Оброблені фактури автоматично отримають статус «Оплачено» і не будуть враховані повторно.</li>
              <li>
                Якщо у водія немає стандартних (дефолтних) значень додаткових коштів, але є підтверджені
                фактури — запис додаткових коштів для нього все одно буде створено.
              </li>
            </ol>
          </Accordion.Body>
        </Accordion.Item>

        {/* 6. Результат */}
        <Accordion.Item eventKey="5">
          <Accordion.Header>6. Який буде результат</Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>Водії самостійно завантажують фактури зі своїх смартфонів, без участі бухгалтерії на етапі подачі.</li>
              <li>Адміністратор витрачає менше часу — потрібно лише перевірити і підтвердити суму ПДВ.</li>
              <li>Суми повернення автоматично і без помилок потрапляють у додаткові кошти водія за потрібний тиждень.</li>
              <li>Виключено ризик задвоєння виплат — оброблені фактури позначаються і більше не враховуються.</li>
              <li>Фото фактур захищені від стороннього доступу за посиланням.</li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </Container>
  );
};

export default InvoicesVatUpdate1206;
